import type { EffectParams } from '@swf/core/store';

enum AppData {
  LiveRaceTerms = 'ldr_tc',
  UKRaceTerms = 'ukgc_tc',
  RaceTerms = 'race_tc',
  UKPrizeGameTerms = 'uk_prizegame_tc'
}

const fetchAppData = async (payload: undefined, { dispatch, request }: EffectParams) => {
  const { body } = await request({
    service: 'casino.player.appdata',
    body: [AppData.UKRaceTerms, AppData.LiveRaceTerms, AppData.RaceTerms, AppData.UKPrizeGameTerms]
  });
  const ukResult = body.find((appdata: { key: string }) => appdata.key === AppData.UKRaceTerms);
  const liveResult = body.find((appdata: { key: string }) => appdata.key === AppData.LiveRaceTerms);
  const raceResult = body.find((appdata: { key: string }) => appdata.key === AppData.RaceTerms);
  const prizeGameResult = body.find(
    (appdata: { key: string }) => appdata.key === AppData.UKPrizeGameTerms
  );
  await dispatch.casino.set({
    UKTermsAccepted: !!ukResult?.value,
    liveRacesTermsAccepted: !!liveResult?.value,
    racesTermsVersionAccepted: raceResult?.value,
    sotdTermsVersionAccepted: prizeGameResult?.value
  });
};

export default fetchAppData;
